module.exports = __webpack_public_path__ + "static/media/poster.c22b7063.png";